import React from 'react';
import { List, Segment } from 'semantic-ui-react';
import { injectIntl } from 'react-intl';


const Footer = ({ intl }) => {
    const currentYear = new Date().getFullYear();

    return (
        <Segment role="contentinfo" padded id="footer">
            <div className="footerTop">
                <List className="footerList">
                    <p className="item list-title">Öffnungszeiten</p>

                    <div role="listitem">
                        <p className="item list-title-small">Montag</p>
                        <p className="item">07:30 - 12:00; 13:15 - 17:00</p>
                    </div>

                    <div role="listitem">
                        <p className="item list-title-small">Dienstag - Donnerstag</p>
                        <p className="item">07:15 - 12:00; 13:15 - 17:00</p>
                    </div>

                    <div role="listitem">
                        <p className="item list-title-small">Freitag</p>
                        <p className="item">07:15 - 12:00; 13:15 - 16:00</p>
                    </div>
                </List>

                <List className="footerList">
                    <p className="item list-title">Adresse</p>
                    
                    <p className="item">Elektro Liechti AG</p>
                    <p className="item">Napfstrasse 49</p>
                    <p className="item">3550 Langnau i. E.</p>
                </List>

                <List className="footerList">
                    <p className="item list-title">Kontakt</p>

                    <a href='tel:+41344083434' className="item">034 408 34 34</a>
                    <a href='mailto:info@elektro-liechti.ch' className="item">info@elektro-liechti.ch</a>

                    <a className="item socialIcon" href="https://www.instagram.com/elektroliechtiag" target="_blank">
                        <i className="ri-instagram-line"></i>
                    </a>
                </List>
            </div>
            <hr />
            <div className='footerBottom'>
                <List className="footerList">
                    <a className="item item-bottom" href="./impressum">Impressum</a>
                    <a className="item item-bottom" href="./datenschutz">Datenschutzerklärung</a>

                    <div role="listitem" className="item item-bottom">
                        <i className="ri-copyright-line"></i> {currentYear} Elektro Liechti AG
                    </div>
                </List>
            </div>
        </Segment>
    );
};

export default injectIntl(Footer);